export enum TemplateIncidentLevel {
    DEFAULT = 'DEFAULT',
    URGENT = 'URGENT'
}
